import type { Assign } from '@ark-ui/react'
import { PasswordInput as ArkPasswordInput } from '@ark-ui/react/password-input'

import { cn } from '~/utils/cn'

import { Label } from '~/components/label'

import type { InputPasswordSharedProps } from './input-password-root'

type InputPasswordLabelProps = Assign<
  React.ComponentProps<typeof ArkPasswordInput.Label>,
  InputPasswordSharedProps
> & {
  readOnly?: boolean
}

export function InputPasswordLabel({
  children,
  size,
  readOnly,
  ...props
}: InputPasswordLabelProps) {
  return (
    <ArkPasswordInput.Label
      {...props}
      className={cn(
        'px-[var(--padding-inset-onepulse)]',
        readOnly && 'text-[var(--color-text-neutral-readonly)]'
      )}
      asChild
    >
      <Label size={size} className={cn(size === 'md' && 'leading-0')}>
        {children}
      </Label>
    </ArkPasswordInput.Label>
  )
}

InputPasswordLabel.displayName = 'InputPasswordLabel'
